import React from "react";
import { useTranslation } from "react-i18next";

import Layout from "../../component/Layout";
import MasterGrid from "../../component/MasterGrid";

import { members_114 } from "./info/114";
import { members_115 } from "./info/115";
import { Box } from "@mui/material";

const Master = () => {
    const { t } = useTranslation();

    return (
        <Layout>
            <Box padding={2}>
                <MasterGrid title={t("page.member.Master.title.1")} members={members_114} />
                <MasterGrid title={t("page.member.Master.title.0")} members={members_115} />
            </Box>
        </Layout>
    )
}

export default Master
